import { render } from "./CarouselControls.vue?vue&type=template&id=65067903&scoped=true"
import script from "./CarouselControls.vue?vue&type=script&lang=js"
export * from "./CarouselControls.vue?vue&type=script&lang=js"

import "./CarouselControls.vue?vue&type=style&index=0&id=65067903&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65067903"]])

export default __exports__